import {
  type MasonryEngineNode,
  type MasonryEngineNodeAction,
  type MasonryEngineNodeRendererProps,
  useMasonryEngineActionEmitter,
} from '@leagueplatform/masonry-engine';
import { Button, Box } from '@leagueplatform/genesis-core';
import { useIsBelowTablet } from 'hooks/use-is-below-tablet/use-is-below-tablet.hooks';

type AuthorizationDetailsButtonProperties = {
  label: string;
};

type AuthorizationDetailsButtonActions = {
  onClick?: MasonryEngineNodeAction;
};

type AuthorizationDetailsButtonNode = MasonryEngineNode<
  'button',
  AuthorizationDetailsButtonProperties,
  AuthorizationDetailsButtonActions
>;

type AuthorizationDetailsButtonProps =
  MasonryEngineNodeRendererProps<AuthorizationDetailsButtonNode>;

export const AuthorizationDetailsButton = ({
  label,
  onClick,
}: AuthorizationDetailsButtonProps) => {
  const isBelowTablet = useIsBelowTablet();
  const invokeAction = useMasonryEngineActionEmitter();

  // Normalize tel:// to tel: to fix browser blocking issue
  // Handles both tel:// (incorrect) and tel: (correct) formats
  const payload = onClick?.payload as Record<string, string> | undefined;
  const normalizedUrl = payload?.url?.replace(/^tel:\/\//, 'tel:');

  return (
    <Box
      css={
        isBelowTablet
          ? {
              '&&': {
                flexBasis: 0,
              },
            }
          : undefined
      }
    >
      <Button
        href={normalizedUrl}
        onClick={(event: React.MouseEvent) => {
          if (onClick) {
            invokeAction({
              event,
              ...onClick,
            });
          }
        }}
        as="a"
        width="fillContainer"
      >
        {label}
      </Button>
    </Box>
  );
};
